import {CONTENTFUL_BASE_URL} from "./api/apiConstants";
import {ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import {keycloak} from "./keycloak";

const cache = new InMemoryCache();
const httpLink = createHttpLink({
    uri: CONTENTFUL_BASE_URL + 
        process.env.CONTENTFUL_SPACE_ID + 
        "/environments/" + 
        process.env.CONTENTFUL_ENVIRONMENT + 
        "?access_token=" + 
        process.env.CONTENTFUL_ACCESS_TOKEN,
});
const authLink = setContext((_, { headers }) => {
    if (keycloak?.authenticated) {
        keycloak.updateToken(process.env.KEYCLOAK_TOKEN_MIN_VALIDITY);
    }

    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
        }
    };
});

export const contentful = new ApolloClient({
    // Provide required constructor fields
    cache: cache,
    link: authLink.concat(httpLink),

    // Provide some optional constructor fields
    defaultOptions: {
        watchQuery: {
            errorPolicy: "all",
        },
        query: {
            errorPolicy: "all"
        },
        mutate: {
            errorPolicy: "all"
        }
    },
});

export const getCachedData = (query, client) => {
    let data;
    try {
        data = client.readQuery({
            query
        });
    } catch (err) {
        data = undefined;
    }

    return data;
};
